<template>
  <div class="login-container">
    <div class="logobox">
      <!-- <img src="../assets/images/logo2.jpg" alt="" /> -->
    </div>
    <div class="login_item" v-if="!isStopping">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size:18px">登录系统</span>
        </div>
        <div class="pswitem">
          <el-form :model="form" status-icon :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <el-form-item prop="username">
              <el-input type="text" v-model="form.username" prefix-icon="el-icon-user" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="form.password" prefix-icon="el-icon-lock" show-password placeholder="密码"></el-input>
              <p ref="passwordError" class="err_tip">
                账号或密码错误
              </p>
            </el-form-item>
            <div class="psw">
              <el-checkbox v-model="checked">记住密码</el-checkbox>
            </div>
            <button id="btn-enterprise-login" type="button" class="am-btn am-btn-secondary" @click="funLogin">
              登录
            </button>
          </el-form>
        </div>
      </el-card>
    </div>

    <div class="con-main" v-else>
      <div class="login_item1">
        <h2>服务器升级通知</h2>
        <p>温馨提示：</p>
        <p>事宜：因系统服务器升级， 维护期间暂停使用。</p>
        <p>维护时间：暂定3月21日 21:00 至 3月22日 18:00</p>
        <p>感谢各位配合，谢谢！</p>
      </div>
    </div>
    <div class="loginPage" v-if="showLoging">
      <i class="loadgif"></i>
    </div>

  </div>
</template>
<script>
  import xz from "../common";
  import router from "./../router";
  // base
  import baseLayout from '../base.vue';
  import Vcode from "vue-puzzle-vcode";
  export default {
    components: {
      Vcode,
    },
    data() {
      return {
        checked: false,
        form: {
          username: "",
          password: "",
        },
        showLoging: false,
        verityImg1: require("../assets/images/promo_detailed_bg.jpg"),
        verityImg2: require("../assets/images/banner4.jpg"),
        verityImg3: require("../assets/images/test4.jpg"),
        verityImg4: require("../assets/images/banner3.jpg"),
        loginIDTxt: '',
        roletype: '',
        rules: {
          username: [{
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          }, ],
          password: [{
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }, ]
        },
        dtlQuery: {
          mainuserid: '',
          useridr: ''
        },
        isStopping:false,
      };
    },
    created() {
      console.log('aa', document.referrer)
      if (window.localStorage.getItem('rempsw')) {
        this.checked = true;
        this.form.username = window.localStorage.getItem('user');
        this.form.password = window.localStorage.getItem('psw');
      }
      var _self = this;
      document.onkeydown = function (e) {
        var key = window.event.keyCode;
        if (key == 13 || key == 100) {
          _self.funLogin();
        }
      }
    },
    methods: {
      //隐藏提示
      hiddenError() {
        let errWords = this.$refs.passwordError;
        if (errWords) {
          errWords.style.cssText += "display:none";
        }
      },
      async funLogin() {
        if (this.form.password && this.form.username) {
          let _this = this;
          //登录
          xz.userLogin(this.form.username, this.form.password).then((r) => {
            // console.log("登录返回", r);
            if (r) {
              Cookies.set("userid-b", r.userid);
              Cookies.set("entid-b", r.entid);
              Cookies.set("token1", r.token);
              // 登录详情id
              this.dtlQuery.useridr = r.userid
              window.localStorage.setItem('psw0', this.form.password)
              this.loginIDTxt = r.userid
              if (this.checked) {
                window.localStorage.setItem('rempsw', true)
                window.localStorage.setItem('user', this.form.username)
                window.localStorage.setItem('psw', this.form.password)
              } else {
                window.localStorage.removeItem('rempsw')
              }
              //登录详情
              xz.getauthJbUserDetail(this.dtlQuery).then(res => {
                // console.log('成员详情',res)
                if (res.status == 'ok') {
                  window.localStorage.setItem('visibleReadingSalary', true)
                  window.localStorage.setItem('visibleReading', true)
                  window.localStorage.setItem('userName', res.msg.Username);
                  window.localStorage.setItem('ganName', res.msg.Strorganname);
                  // window.localStorage.setItem('strTableId', res.rolelist[0].tableids)
                  window.localStorage.setItem('isPartner', res.msg.StrIspartner);
                  window.localStorage.setItem('roleName', res.msg.StationName);
                  let role = localStorage.loginRoletype;
                  if (localStorage.lastID && localStorage.lastID == r.userid) {
                    if (res.msg) {
                      this.roletype = res.msg.Strstation;
                      window.localStorage.setItem('loginRoletype', res.msg.Strstation) //岗位id
                      window.localStorage.setItem('gancode', res.msg.Strorgancode) //组织机构码
                    }
                  } else {
                    this.roletype = res.msg.Strstation;
                    window.localStorage.setItem('loginRoletype', res.msg.Strstation)
                    window.localStorage.setItem('gancode', res.msg.Strorgancode)
                  }
                  if (res.msglabel != undefined) {
                    window.localStorage.setItem('tableids', JSON.stringify(res.msglabel))
                  }
                  //获取菜单路由权限
                  xz.bgetLoginauthPowerInf(r.userid)
                    .then((res2) => {
                      localStorage.setItem("lastID", r.userid)
                      // console.log("动态路由", res2);
                      if (res2.status == 'ok') {
                        let resRouter = res2.msg;
                        if (_this.isNull(resRouter)) {
                          this.$message({
                            message: '该账号未配置权限！请联系管理员。',
                            type: "warning"
                          })
                          return
                        }
                        // window.localStorage.setItem(
                        //   "activeRoutes",
                        //   JSON.stringify(resRouter.parent)
                        // );
                        let activeRouter = resRouter.parent;
                        let arrayRouter = []
                        // console.log("router",activeRouter);
                        this.generaMenu(arrayRouter, activeRouter);
                        localStorage.setItem("defaultIndex", 0);
                        // 存储到本地中，不然刷新无法获取路由 这个要加上路由守卫
                        localStorage.setItem("router", JSON.stringify(activeRouter))
                        this.$store.dispatch("SetRouter", activeRouter)
                        activeRouter = arrayRouter
                        localStorage.setItem("activeRouter", JSON.stringify(activeRouter))
                        // console.log("动态路由",activeRouter);
                        this.$router.addRoutes(activeRouter)
                        // 存入vuex
                        setTimeout(() => {
                          location.reload()
                        })
                        // console.log("全部路由",this.$router);
                      } else {
                        this.$message({
                          message: res2.msg,
                          type: "error"
                        })
                        return
                      }
                    })
                    .catch((err) => {
                      console.log("登录错误", err)
                    })
                }
              });
            } else {
              let errWords = this.$refs.passwordError
              errWords.style.cssText += "display:block"
              _this.showLoging = false
            }
          })
        }
      },
      //去重
      reductionFn(arr) {
        let res = new Map();
        return arr.filter(item => !res.has(item.powercode) && res.set(item.powercode, item.powercode));
      },
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN'
      },
      generaMenu(routes, data) {
        // console.log('generaMenu', data)
        let menu;
        data.forEach(item => {
          // console.log('sss', item)
          menu = {
            path: item.path === '#' ? item.path + '_key' : item.path, //item.path === '#' ? item.path + '_key' : item.path
            component: (item.children && item.children.length > 0) ? baseLayout : (resolve) => require([`@/views/${item.powerEnName}${item.path}`], resolve),
            // hidden: true,
            // redirect: 'noRedirect',
            // alwaysShow: false,
            checked: false,
            activeMenu: item.activeMenu,
            name: item.name,
            powerEnName: item.powerEnName,
            powercode: item.powercode,
            powername: item.powername,
            meta: {
              title: item.meta.title,
              checked: false,
              icon: item.meta.icon,
              //   noCache: true,
              //   breadcrumb: true,
              //   affix: false
            },
            children: []
          }
          if (item.children && item.children.length > 0) {
            this.generaMenu(menu.children, item.children)
          }
          routes.push(menu)
        });
      }
    }
  }
</script>
<style scoped>
  .logo-img img {
    width: 60%;
    height: auto;
    max-height: 284px;
    display: block;
  }

  .hasAccount {
    width: 326px;
    margin: 0 auto 5px auto;
  }

  .login-container input {
    font-size: 16px;
  }

  .hasAccount {
    font-size: 16px;
  }

  .login-container .login-box .am-form .am-form-group {
    border-bottom: 2px solid #5f4b8b;
    overflow: hidden;
  }

  .login-container .login-box .am-form .am-form-group label {
    float: left;
  }

  .login-container .login-box .logo-img {
    /* width: 219px;
  margin: 0 auto; */
    display: flex;
    justify-content: center;
  }

  .login-container .login-box {
    width: 326px;
    margin: 0 auto;
  }

  .login-container .login-box .am-form {
    margin-top: 68px;
  }

  .login-container .login-box .am-form .am-form-group input {
    width: 265px;
    float: left;
    outline: none;
    margin-left: 10px;
    border: 0;
    background: 0 0;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 0.5em;
    line-height: 1.2;
  }

  .am-btn-secondary {
    width: 280px;
    height: 45px;
    background: #58a3f6;
    border-color: #58a3f6;
    /* border-radius: 27px; */
    display: block;
    margin: 5px auto 0;
    font-size: 16px;
    font-weight: 400;
    outline: none;
    padding: 0.5em 1em;
    /* vertical-align: middle; */
    color: #fff;
  }

  .login-container .login-box .am-form .am-form-group label i {
    font-size: 24px;
    color: #5f4b8b;
  }

  label {
    display: inline-block;
    margin-bottom: 5px;
    font-weight: 700;
  }

  .loginPage {
    position: absolute;
    width: 100%;
    height: 100vh;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    background: rgba(255, 255, 255, 0.4);
  }

  .logobox img {
    /* width: 175px; */
    width: 100px;
    margin: 20px 0 0 20px;
  }

  .login_item {
    float: right;
    margin-right: 15%;
    margin-top: -100px;
    height: calc(100vh - 81px);
    display: flex;
    align-items: center;
  }

  .box-card {
    width: 360px;
  }

  .pswitem {
    padding: 0 20px;
  }

  .clearfix {
    text-align: center;
  }

  .psw {
    height: 30px;
    padding-left: 5px;
  }

  .err_tip {
    color: #f56c6c;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    display: none;
  }

  .con-main {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .login_item1 {
    width: 360px;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-align: center;
    font-size: 16px;
    line-height: 1.6;
  }

  .login_item1 h2 {
    margin-bottom: 10px;
    font-size: 24px;
  }

  .login_item1 p {
    margin: 5px 0;
  }
</style>
<style>
  .psw .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #5f4b8b !important;
  }

  .psw .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #5f4b8b !important;
    border-color: #5f4b8b !important;
  }

  .login_item .el-card__body {
    background-color: rgba(230, 243, 252, 0.5);
  }

  .login_item .el-card__header {
    background-color: rgba(243, 248, 252, 0.9);
  }

  .pswitem i.el-icon-circle-close {
    display: none;
  }

  .pswitem i.el-icon-circle-check {
    display: none;
  }
</style>